export const SLACK_REQUIRED_SCOPES: readonly string[] = [
  "channels:history",
  "channels:read",
  "channels:join",
  "groups:history",
  "groups:read",
  "im:history",
  "im:read",
  "files:read",
  "team:read",
  "users:read",
  "users:read.email",
  "chat:write",
  "files:write",
  "reactions:write",
  "pins:write",
  "chat:write.public",
];

export function parseGrantedSlackScopes(metadata: unknown): string[] {
  if (!metadata || typeof metadata !== "object") return [];
  const raw = (metadata as Record<string, unknown>).grantedScopes;
  if (Array.isArray(raw)) {
    return raw.filter(
      (s): s is string => typeof s === "string" && s.length > 0
    );
  }
  if (typeof raw === "string") {
    return raw.split(/[\s,]+/).filter((s) => s.length > 0);
  }
  return [];
}

const V2_ADDED_SCOPES: readonly string[] = [
  "reactions:write",
  "pins:write",
  "chat:write.public",
];

// Installs without persisted `grantedScopes` predate scope tracking — treat them
// as needing reconnect for the v2-added scopes so the badge fires.
export function getMissingSlackScopes(metadata: unknown): string[] {
  const granted = parseGrantedSlackScopes(metadata);
  if (granted.length === 0) return [...V2_ADDED_SCOPES];
  return SLACK_REQUIRED_SCOPES.filter((scope) => !granted.includes(scope));
}

export function needsSlackReconnect(connector: {
  type: string;
  metadata?: unknown;
  completedOauth?: boolean;
}): boolean {
  if (connector.type !== "slack") return false;
  if (connector.completedOauth === false) return false;
  return getMissingSlackScopes(connector.metadata).length > 0;
}
